import type { CSSProperties } from 'react'

// Monochrome WeTook "W" mark. Single path filled with `currentColor`, so it
// adapts to the surrounding text color — black on light chrome, white on dark.
// Use it where a theme-adaptive brand mark is needed (e.g. the My app, whose
// brand is neutral rather than the red wetook-mark.svg).
export function WetookMark({ className, style }: { className?: string; style?: CSSProperties }) {
  return (
    <svg
      viewBox="0 0 259.15 157.81"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M160.82,142.74l-.09-38.62-38.64,38.55-26.5.08-.22-38.88-38.9,38.82-26.45-.02.05-83.12c1.88-2.58,4.09-4.01,6.22-6.13l33.35-33.26c1.4-1.94,2.86-3.37,4.76-5.03l24.13-.03.13,41.19,41.24-41.21,23.91.02.1,41.15,41.19-41.15,24-.05.03,83.21-44.38,44.4-23.93.07Z"
      />
    </svg>
  )
}
